import React from 'react';
import { UrgencyBanner } from './components/UrgencyBanner';
import { SocialProofPopup } from './components/SocialProofPopup';
import { Hero } from './components/Hero';
import { PainPoints } from './components/PainPoints';
import { Bridge } from './components/Bridge';
import { Features } from './components/Features';
import { Benefits } from './components/Benefits';
import { Pricing } from './components/Pricing';
import { PricingCountdown } from './components/PricingCountdown';
import { Testimonials } from './components/Testimonials';
import { Guarantee } from './components/Guarantee';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
export function App() {
  return <div className="min-h-screen font-sans text-gray-800 selection:bg-sage-200 selection:text-sage-900" data-id="element-0">
      <UrgencyBanner data-id="element-1" />
      <SocialProofPopup data-id="element-2" />
      <main data-id="element-3">
        <Hero data-id="element-4" />
        <PainPoints data-id="element-5" />
        <Bridge data-id="element-6" />
        <Features data-id="element-7" />
        <Benefits data-id="element-8" />
        <Pricing data-id="element-9" />
        <PricingCountdown data-id="element-10" />
        <Testimonials data-id="element-11" />
        <Guarantee data-id="element-12" />
        <FAQ data-id="element-13" />
        <FinalCTA data-id="element-14" />
      </main>
    </div>;
}